
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/configurator/code-snippet/[[...subpath]]",
      function () {
        return require("private-next-pages/configurator/code-snippet/[[...subpath]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/configurator/code-snippet/[[...subpath]]"])
      });
    }
  